import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslations } from 'use-intl';

import { ForgotPasswordContent } from '@/screens/forgot-password/ForgotPasswordContent';

export const Route = createFileRoute('/_app/forgot-password/')({
  component: ForgotPasswordRoute,
});

function LoadingSpinner() {
  const t = useTranslations('auth');
  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        <p className="text-sm text-muted-foreground">{t('loading')}</p>
      </div>
    </div>
  );
}

function ForgotPasswordRoute() {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <ForgotPasswordContent />
    </Suspense>
  );
}
